import { render, staticRenderFns } from "./pop_pay_stat.vue?vue&type=template&id=5f853f7b&scoped=true&"
import script from "./pop_pay_stat.vue?vue&type=script&lang=js&"
export * from "./pop_pay_stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f853f7b",
  null
  
)

export default component.exports